import { applyMiddleware, combineReducers, createStore } from 'redux';
import { dataService } from './dataservice';
import {
  aboutReducer,
  activeTabReducer,
  cartReducer,
  chartReducer,
  configuratorReducer,
  currentNodeReducer,
  dispatchReducer,
  exportReducer,
  filterSelectorReducer,
  feasibilityReducer,
  helpImagesReducer,
  hierarchyNodeReducer,
  identityReducer,
  importReducer,
  modelConfiguratorReducer,
  pinnedItemsReducer,
  popupReducer,
  priceReducer,
  productsReducer,
  repositoryReducer,
  resourceReducer,
  screenReducer,
  searchReducer,
  detailedSearchReducer, 
  settingsReducer,
  siteSettingsReducer,
  viewSettingsReducer,
  viewsReducer,
  orderCodeReducer,
  complexSelectorReducer,
  stockReducer,
  superCodeReducer,
  mobileViewReducer,
  mobilePageViewReducer,
  showFooterReducer,
  showConfigureReducer,
  flagReducer,
  dialogReducer,
  mobileItemDetailReducer,
  currentPageReducer,
  screenSizeReducer,
  currentCartItemReducer,
  blurOnSearchReducer,
  filterSelectedReducer
  // stockFilterReducer
} from '.';
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const AppStore = createStore(
  combineReducers( {
    about: aboutReducer,
    activeTab: activeTabReducer,
    busyState: dispatchReducer,
    cart: cartReducer,
    chart: chartReducer,
    configurations: configuratorReducer,
    codeSettings: repositoryReducer( 'orderCodes' ),
    currentNode: currentNodeReducer,
    exportFileTypes: exportReducer,
    filterSelectors: filterSelectorReducer( 'selector' ),
    helpImages: helpImagesReducer,
    imports: importReducer,
    modelConfigurator: modelConfiguratorReducer,
    feasibilityConfiguration: feasibilityReducer,
    message: repositoryReducer( 'message' ),
    node: hierarchyNodeReducer,
    orderCodes: orderCodeReducer,
    pinnedItems: pinnedItemsReducer,
    popup: popupReducer,
    prices: priceReducer,
    products: filterSelectorReducer( 'products' ),
    productsStore: productsReducer,
    resources: resourceReducer,
    screen: screenReducer,
    searchResult: searchReducer,
    pageResult: detailedSearchReducer,
    selector: repositoryReducer( 'selector', selector => selector.name ),
    settings: settingsReducer,
    siteSettings: siteSettingsReducer,
    user: identityReducer,
    viewSettings: viewSettingsReducer,
    views: viewsReducer,
    complexSelectors: complexSelectorReducer,
    superCode: superCodeReducer,
	  stocks: stockReducer,
    mobileContentView: mobileViewReducer,
    mobileViewPage: mobilePageViewReducer,
    showFooter: showFooterReducer,
    showConfigure: showConfigureReducer,
    flags: flagReducer,
    dialog:dialogReducer,
    mobileItem:mobileItemDetailReducer,
    currentPage: currentPageReducer,
    screenSize: screenSizeReducer,
    currentCartItem: currentCartItemReducer,
    blurOnSearch: blurOnSearchReducer,
    filterSelected: filterSelectedReducer
    // stockFilter: stockFilterReducer
  } ), 
  applyMiddleware( dataService )
);
//composeEnhancers( applyMiddleware( dataService ) )